import { render, staticRenderFns } from "./draw-controls.vue?vue&type=template&id=a10b53c6&scoped=true"
import script from "./draw-controls.vue?vue&type=script&lang=js"
export * from "./draw-controls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10b53c6",
  null
  
)

export default component.exports